import type { GuidanceResponse, Task } from '@core/fhir-r4/fhir';

export interface PreTriageGatewayBundleResource {
  resourceType?: string;
  [key: string]: unknown;
}

export interface PreTriageGatewayBundleEntry {
  resource?: PreTriageGatewayBundleResource;
}

export interface PreTriageGatewayBundle {
  resourceType?: string;
  entry?: readonly PreTriageGatewayBundleEntry[];
}

export interface PreTriageGatewayResult {
  guidanceResponse: GuidanceResponse;
  bundle?: PreTriageGatewayBundle;
}

export type PreTriageGatewayErrorCode = 'offline' | 'request-failed' | 'retry-exhausted' | 'session-required';

export class PreTriageGatewayError extends Error {
  public constructor(
    public readonly code: PreTriageGatewayErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'PreTriageGatewayError';
  }
}

export interface PreTriageGateway {
  applyTask(taskPayload: Task): Promise<PreTriageGatewayResult>;
}